import { render, staticRenderFns } from "./UserManage.vue?vue&type=template&id=ab5fb42e&scoped=true&"
import script from "./UserManage.vue?vue&type=script&lang=js&"
export * from "./UserManage.vue?vue&type=script&lang=js&"
import style0 from "./UserManage.vue?vue&type=style&index=0&id=ab5fb42e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5fb42e",
  null
  
)

export default component.exports